module.exports = __webpack_public_path__ + "img/Congratulations_Message.0d4138ac.png";